
import { useMemo } from 'react'
import TablePopup from 'src/component/popup/TablePopup'
import { GetPrevMdicalServices } from 'src/requests/PatientMedicalServices'

const MedicalServiceHistoryPopup = ({ id, modalId }: { id: number|null, modalId: any }) => {

    const columns = useMemo(() => [
        {
            Header: "decisionMedicalServiceId",
            accessor: "decisionMedicalServiceId",
        },
        {
            Header: "serviceName",
            accessor: "serviceName",
        },
        {
            Header: "serviceType",
            accessor: "serviceType",
        },
        {
            Header: "cost",
            accessor: "cost",
        },
        {
            Header: "status",
            accessor: "status",
        },
        {
            Header: "notes",
            accessor: "notes",
        },
    ], [])

    return (
        <TablePopup
            fetchId={id}
            apiFunc={GetPrevMdicalServices}
            columns={columns}
            refModal={modalId}
            onClosePopup={() => modalId.current.click()}
            title={"medical-service-history"} />
    )
}

export default MedicalServiceHistoryPopup